export default __webpack_public_path__ + "assets/card-logo-american-express-component.38b25332.svg";